$(document).ready(function () {

  $(".coupons_discounts_text").html("$370");
  
  //compariosn table heading
$(".compariosn_table_heading_text").html("Halloween Sale");
$(".compariosn_table_heading_text_offer").html("Halloween Sale");
$(".compariosn_table_extra_gifts").html("Spooky Candles *For the FIRST 50 CUSTOMERS");
$(".product-tittle-offer").html(Shopify.country === "IT" ? "Easter Savings - Limited Time Offer" : "🎃 Halloween Sale - Limited Time Offer"); // IT = Italy market text, else default. Only for smileadvantage, flex and nigtadvantage, flex
$(".product_hot_tag").html('<img src="https://cdn.shopify.com/s/files/1/0685/4115/3567/files/Hot-tag-Halloween.svg?v=1791189831" alt="hot-tag" class="hot-tag">');

// // pricing section
//   $(document).ready(function () {

//   /* ── MARQUEE ───────────────────────────────────── */
//   var MARQUEE_TEXT   = 'HALLOWEEN Sale $370 OFF + Free Whitening Kit & Retainers';
//   var MARQUEE_ICON   = 'https://cdn.shopify.com/s/files/1/0685/4115/3567/files/pumkin-image.svg?v=1791185772'; // paste your CDN url
//   var MARQUEE_BG     = '#FFDB30';
//   var MARQUEE_COLOR  = '#0a2849';

//   $('.pricing-marquee-wrap').css('background-color', MARQUEE_BG);
//   $('.pricing-marquee-text').css('color', MARQUEE_COLOR);

//   // icon (show it and set src)
//   $('.pricing-marquee-icon').attr('src', MARQUEE_ICON).css('display', '');

//   // ── BADGE — Card 1 ───────────────────────────────────
//   // Replace "all day" with whatever your Plan Name is (lowercase)
//   var $b1 = $('[data-plan="all-day plan"] .free-tag-badge');
//   $b1.css('background-color', '#0A2849');
//   $b1.find('.pricing-highlighted-text').html('+ FREE').css('color', '#FFDB30');
//   $b1.find('.pricing-offer-regular-text').html('Aligner Essentials (Worth $40)').css('color', '#FFF');

//   // ── BADGE — Card 2 ───────────────────────────────────
//   // Replace "nighttime" with whatever your Plan Name is (lowercase)
//   var $b2 = $('[data-plan="nightonly plan"] .free-tag-badge');
//   $b2.css('background-color', '#FFF');
//   $b2.find('.pricing-highlighted-text').html('+ FREE').css('color', '#E53935');
//   $b2.find('.pricing-offer-regular-text').html('Aligner Essentials (Worth $40)').css('color', '#0a2849');
// });

  // SmileAdvantage
  $(".smileadvantage_price_text").html("<del>$1,095</del> $725");
   $(".smileadvantage_price_text-texas").html("<del>$1,095</del> <strong>$725</strong>");
  $(".smileadvantage__single_price_text").html("$725");
  $(".smileadvantage__single_del_price_text").html("$1,095");
  $(".night-guard__price_text").html("$120");

  // SmileFlex
  $(".smileflex_price_text").html("$60");

  // SmileFlex Easy
  $(".smileflex_easy_price_text").html("$92");
  $(".smileflex_easy_downpayment").html("$395");
  $(".smileflex_easy_total").html("$1,039");
  $(".smileflex_easy_months").html("7 months");

  // NightAdvantage
   $(".nightadvantage_price_text").html("<del>$1,295</del> $925");
     $(".nightadvantage_price_text-texas").html("<del>$1,295</del><strong> $925 </strong>");
  $(".nightadvantage__single_price_text").html("$925");
  $(".nightadvantage__single_del_price_text").html("$1,295");

  // NightFlex
  $(".nightflex_price_text").html("$77");

  // NightFlex Easy
  $(".nightflex_easy_price_text").html("$114");
  $(".nightflex_easy_downpayment").html("$444");
  $(".nightflex_easy_total").html("$1,239");
  $(".nightflex_easy_months").html("7 months");

  // Kit First Plan
  $(".kit_first_price_text").html("<del>$75</del> <strong>$29.99</strong>");
  $(".kit_first_price_text_regular").html("$29.99");

  // Smile Protection Plan
  $(".smile_protection_plan_price_text").html("<del>$680</del> $499");

  // Sonic Electric Tootbrush
  $(".sonic_electric_toothbrush_price_text").html("$49.99");
  $(".sonic_electric_toothbrush_price_del_text").html("<del>$75</del>");

  // Aligner Cleaner + Whitener
  $(".aligner_cleaner_price_text").html("$25");
  $(".aligner_cleaner_price_del_text").html("<del>$39.99</del>");

  // Aligner Cleaner + Whitener
  $(".aligner_cleaner_price_text").html("$25");
  $(".aligner_cleaner_price_del_text").html("<del>$39.99</del>");

  // Aligner Cleaner + Whitener
  $(".aligner_cleaner_price_text").html("$25");
  $(".aligner_cleaner_price_del_text").html("<del>$39.99</del>");


  // Teeth Whitening Pen
  $(".teeth_whitening_kit_price_text").html("$29.99");
  $(".teeth_whitening_kit_del_price_text").html("<del>$49.99</del>");
  $(".retainers_price_text").html("$125");
  $(".custom-fit-hard-night-guard-dual-arch-price").html("$125");
  $(".custom-soft-night-guard-dual-price").html("$125");
  $(".retainers-del-price").html("$150");
  $(".teeth_whitening_pen_text").html("$15");
  $(".teeth_whitening_pen_del_text").html("<del>$19.99</del>");
  $(".pull_tool_text").html("$15");
  $(".chewies_text").html("$15");
  $(".retainers_case_text").html("$14.99");
  $(".retainers_case_price_del_text").html("<del>$25.00</del> ");
  $(".cheek_retractor_text").html("$15");
  $(".gift_card_text").html("$15");
  
  
  $(".night_guard_text").html("$115");
  $(".night_guards_text").html("$125");
  $(".night_guard_del_text").html("$199")
  $(".mouth_guard_text").html("$125");
  $(".mouth-guards-del-price").html("$199");
  $(".soft_night_guard_price").html("$115");
  $(".hybrid_night_guard_price").html("$120");
  $(".hybrid_night_guard_del_price").html("$210");
  $(".hard_night_guard_price").html("$115");
  $(".hard_night_guard_del_text").html("$199");

   // Care Kit
  $(".care_kit_text").html("$40");
   $(".care_kit_del_price_text").html("<del>$75.00</del>");


  // military-discount
  $(".military_discount_text").html("$25");


  // retainer
  $(".retainer_price_text").html("$125");
  $(".retainer_price_del_text").html("$150");
  // teeth-whitening-kit
  $(".teeth_whitening_kit_price_text_regular").html("$34.99");
  $(".teeth_whitening_kit_price_text_wireless").html("$24.99");
  $(".teeth_whitening_kit_del_price_text").html("$49.99");
  $(".teeth_whitening_kit_APR_text").html("$11.66/mo");
  $(".mouth-guards-price").html("$140");
  $(".night-guards-del-price").html("$199");
  $(".night-guards-price").html("$115");
  $(".ultrasonic-cleaner").html("$39.99");
  $(".uv-ultrasonic-cleaner-price").html("$39.99");

  //retainer-set-pricing
  $(".retainer_2set_price_text").html("$225");
  $(".retainer_2set_del_price_text").html("$300");
  $(".retainer_4set_price_text").html("$295");
  $(".retainer_4set_del_price_text").html("$600");
  $(".retainer_8set_price_text").html("$495");
  $(".retainer_8set_del_price_text").html("$1,200");
  $(".cleansing-tablets-for-aligners-retainers-dentures-price").html("$8.99");
  $(".cleansing-tablets-for-aligners-retainers-dentures-120-pisces-price").html("$20.00");

  // scan-center-pricing
  $(".3D-scan-price-text").html("$150");

  (function () {
  var lang = (window.Shopify && Shopify.locale ? String(Shopify.locale) : '')
               .toLowerCase().split('-')[0];
  if (/^\/es(\/|$)/i.test(location.pathname)) lang = 'es';

  var CONSENT = {
    en: `By checking this box, I provide prior express written consent to receive recurring marketing emails, SMS/texts, and calls (including via autodialer or artificial/prerecorded voice, and including promotions, offers, and reminders such as abandoned cart follow-ups) from ALIGNERCO CORP. at the contact details provided. I also consent to the recording and monitoring of calls and SMS for quality assurance, training, and compliance purposes. Consent is not a condition of purchase. Message frequency varies. Message & data rates may apply. Opt out anytime (unsubscribe, STOP, or request removal). View <a href='https://alignerco.com/policies/privacy-policy' target='_blank'>Privacy Policy</a>  &amp; <a href='https://alignerco.com/policies/terms-of-service' target='_blank'>Terms</a>.`,

    es: `Al marcar esta casilla, otorgo mi consentimiento previo, expreso y por escrito para recibir correos electrónicos, mensajes SMS/texto y llamadas de marketing recurrentes (incluidos los realizados mediante marcador automático o voz artificial/pregrabada, y que incluyen promociones, ofertas y recordatorios como avisos de carrito abandonado) de ALIGNERCO CORP. a los datos de contacto proporcionados. También consiento la grabación y el monitoreo de las llamadas y los SMS con fines de control de calidad, capacitación y cumplimiento. El consentimiento no es una condición de compra. La frecuencia de los mensajes varía. Pueden aplicarse tarifas de mensajes y datos. Puedes cancelar en cualquier momento (darte de baja, responder STOP o solicitar la eliminación). Consulta la <a href='https://alignerco.com/policies/privacy-policy' target='_blank'>Política de Privacidad</a>  &amp; los <a href='https://alignerco.com/policies/terms-of-service' target='_blank'>Términos</a>.`
  };

  $(".consent-forms-text").html(CONSENT[lang] || CONSENT.en);
})();

//   $(".consent-forms-text").html(`By checking this box, I provide prior express written consent to receive recurring marketing emails, SMS/texts, and calls (including via autodialer or artificial/prerecorded voice, and including promotions, offers, and reminders such as abandoned cart follow-ups) from ALIGNERCO CORP. at the contact details provided. I also consent to the recording and monitoring of calls and SMS for quality assurance, training, and compliance purposes. Consent is not a condition of purchase. Message frequency varies. Message & data rates may apply. Opt out anytime (unsubscribe, STOP, or request removal). View <a href='https://alignerco.com/policies/privacy-policy' target='_blank'>Privacy Policy</a>  &amp; <a href='https://alignerco.com/policies/terms-of-service' target='_blank'>Terms</a>.`
// );

});


// ================================
// Global App Config
// ================================

window.APP_CONFIG = {
  SCRIPT_URL_AsSESMENT_FORM:
    "https://script.google.com/macros/s/AKfycbxbuKXHTt-X-bv2aIpOvronppWsjK3X-NxzCLU7KJ0JK30j3w3wyVF2u4iAzrQS-XSu9w/exec",

  THANK_YOU_URL_DAY_AsSESMENT_FORM:
      "https://alignerco.com/pages/day-quiz-success",

        THANK_YOU_URL_NIGHT_AsSESMENT_FORM:
            "https://alignerco.com/pages/night-quiz-success"
};